import { render, staticRenderFns } from "./batch-update-role.vue?vue&type=template&id=5e089368&scoped=true"
import script from "./batch-update-role.vue?vue&type=script&lang=ts"
export * from "./batch-update-role.vue?vue&type=script&lang=ts"
import style0 from "./batch-update-role.vue?vue&type=style&index=0&id=5e089368&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e089368",
  null
  
)

export default component.exports